"use strict";

/**
 * Leirikoski kiinteistöpäivystäjä schedule.
 * Shared between the Cloud Function (getPublicKiinteistopaivystaja)
 * and the Vue component (Leirikoski.vue).
 *
 * Format: ["W/GGGG", "Primary person", "Secondary person"]
 * Week key format matches dayjs().isoWeek() + "/" + dayjs().isoWeekYear()
 */
const TALONHENKILOT = [
  ["1/2026", "Sartomäki Sami", "Lindgren Ville"],
  ["2/2026", "Latva Aimo", "Kankaristo Valtteri"],
  ["3/2026", "Leino Jouni", "Lähteenmäki Mika"],
  ["4/2026", "Lindgren Ville", "Pentti Pasi"],
  ["5/2026", "Kankaristo Valtteri", "Yli-Anttila Sara"],
  ["6/2026", "Lähteenmäki Mika", "Raikisto Mari"],
  ["7/2026", "Pentti Pasi", "Rautiainen Joni"],
  ["8/2026", "Peltomaa Joel", "Heiskala Jani-Petteri"],
  ["9/2026", "Raikisto Mari", "Reponen Simo"],
  ["10/2026", "Rautiainen Joni", "Salonen Tomi"],
  ["11/2026", "Reponen Matti", "Toivanen Tuula"],
  ["12/2026", "Reponen Simo", "Uusikorpi Rami"],
  ["13/2026", "Salonen Tomi", "Vehkalahti Max"],
  ["14/2026", "Toivanen Tuula", "Pihlajamäki Pasi"],
  ["15/2026", "Uusikorpi Rami", "Yli-Anttila Tomi"],
  ["16/2026", "Vehkalahti Max", "Ylinen Jarkko"],
  ["17/2026", "Pihlajamäki Pasi", "Halme Jari"],
  ["18/2026", "Yli-Anttila Tomi", "Haapaniemi Eero"],
  ["19/2026", "Ylinen Jarkko", "Reponen Matti"],
  ["20/2026", "Halme Jari", "Heiskala Juha-Pekka"],
  ["21/2026", "Haapaniemi Eero", "Heiskala Matti"],
  ["22/2026", "Heiskala Jani-Petteri", "Peltomaa Joel"],
  ["23/2026", "Heiskala Juha-Pekka", "Jalava Juuso"],
  ["24/2026", "Heiskala Matti", "Sartomäki Sami"],
  ["25/2026", "Yli-Anttila Sara", "Latva Aimo"],
  ["26/2026", "Jalava Juuso", "Leino Jouni"],
  ["27/2026", "Sartomäki Sami", "Lindgren Ville"],
  ["28/2026", "Latva Aimo", "Kankaristo Valtteri"],
  ["29/2026", "Leino Jouni", "Lähteenmäki Mika"],
  ["30/2026", "Lindgren Ville", "Pentti Pasi"],
  ["31/2026", "Kankaristo Valtteri", "Yli-Anttila Sara"],
  ["32/2026", "Lähteenmäki Mika", "Raikisto Mari"],
  ["33/2026", "Pentti Pasi", "Rautiainen Joni"],
  ["34/2026", "Peltomaa Joel", "Heiskala Jani-Petteri"],
  ["35/2026", "Raikisto Mari", "Reponen Simo"],
  ["36/2026", "Rautiainen Joni", "Salonen Tomi"],
  ["37/2026", "Reponen Matti", "Toivanen Tuula"],
  ["38/2026", "Reponen Simo", "Uusikorpi Rami"],
  ["39/2026", "Salonen Tomi", "Vehkalahti Max"],
  ["40/2026", "Toivanen Tuula", "Pihlajamäki Pasi"],
  ["41/2026", "Uusikorpi Rami", "Yli-Anttila Tomi"],
  ["42/2026", "Vehkalahti Max", "Ylinen Jarkko"],
  ["43/2026", "Pihlajamäki Pasi", "Halme Jari"],
  ["44/2026", "Yli-Anttila Tomi", "Haapaniemi Eero"],
  ["45/2026", "Ylinen Jarkko", "Reponen Matti"],
  ["46/2026", "Halme Jari", "Heiskala Juha-Pekka"],
  ["47/2026", "Haapaniemi Eero", "Heiskala Matti"],
  ["48/2026", "Heiskala Jani-Petteri", "Peltomaa Joel"],
  ["49/2026", "Heiskala Juha-Pekka", "Jalava Juuso"],
  ["50/2026", "Heiskala Matti", "Sartomäki Sami"],
  ["51/2026", "Yli-Anttila Sara", "Latva Aimo"],
  ["52/2026", "Jalava Juuso", "Leino Jouni"],
];

/**
 * Returns talonhenkilot entries for a range of weeks around today.
 * @param {object} [options]
 * @param {number} [options.weeksBefore=1]  Weeks before current to include
 * @param {number} [options.weeksAhead=2]   Weeks ahead of current to include
 * @returns {{ week: string, primary: string, secondary: string, current: boolean }[]}
 */
function getTalonhenkilotForRange(options) {
  const { weeksBefore = 1, weeksAhead = 2 } = options || {};
  const dayjs = require("dayjs");
  const isoWeek = require("dayjs/plugin/isoWeek");
  dayjs.extend(isoWeek);

  const results = [];
  for (let offset = -weeksBefore; offset <= weeksAhead; offset++) {
    const d = dayjs().add(offset, "week");
    const weekKey = d.isoWeek() + "/" + d.isoWeekYear();
    const entry = TALONHENKILOT.find((h) => h[0] === weekKey);
    results.push({
      week: weekKey,
      primary: entry ? entry[1].trim() : null,
      secondary: entry ? entry[2].trim() : null,
      current: offset === 0,
    });
  }
  return results;
}

module.exports = { TALONHENKILOT, getTalonhenkilotForRange };
